import React, { Component } from "react";
import { connect } from "react-redux";
import { LinearProgress } from "material-ui";
import { CustomDrawer } from "../../Shared";
import moment from "moment";
import { FullWidthButton, PrimaryButton, Alert } from "../../Shared";
import Calendar from "./Calendar";
import TimeSlot from "./TimeSlot";
import * as STEP_KEYS from "../../../consts";
import {
  isDayIncluded,
  getDatePart,
  isSameDay,
  getDistinctDateFormats,
  elementScrollTop
} from "../../../../../utils";
import { scheduleSelector } from "../../../selectors";
import {
  getTimeSlotsInPeriod,
  getAvailableDays,
  toggleControl,
  goToPage,
  updateAppointmentDetail,
  goToStep,
  completeStep,
  requireWaitingList,
  selectPreferredTime
} from "../../../actions";

class ScheduleDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMonth: undefined,
      selectedDay: undefined,
      timeSlots: []
    };
  }

  componentWillReceiveProps = nextProps => {
    if (
      nextProps.timeSlots.length === 0 &&
      this.props.timeSlots.length !== 0 &&
      this.state.timeSlots.length !== 0
    ) {
      this.setState({ selectedDay: undefined, timeSlots: [] });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      prevState.timeSlots.length !== this.state.timeSlots.length &&
      this.state.timeSlots.length !== 0
    ) {
    }
  };

  getTimeSlots = day => {
    const timeSlots = this.props.timeSlots.filter(ts => {
      const date = new Date(ts.startDateTime);
      return isSameDay(date, day);
    });
    this.setState({ timeSlots });
  };

  getUniqueTimeSlots = timeslots => {
    return timeslots
      .reduce((current, next) => {
        if (
          !current.some(
            s =>
              s.startDateTime === next.startDateTime &&
              s.endDateTime === next.endDateTime
          )
        ) {
          current.push(next);
        }
        return current;
      }, [])
      .map(({ startDateTime, endDateTime }) => {
        return { startDateTime, endDateTime };
      });
  };

  handleDayClick = day => {
    if (isDayIncluded(day, this.props.availableDays)) {
      this.setState({ selectedDay: getDatePart(day) });
      this.getTimeSlots(day);
      elementScrollTop(
        ".schedule_drawer .select-drawer",
        ".client-portal-calendar",
        -85
      );
    }
  };

  handleMonthChange = month => {
    this.setState({
      selectedDay: undefined,
      selectedMonth: month,
      timeSlots: []
    });
    const { timeSlots, availableLocations, isPhoneConsult } = this.props;

    const ditinctMonths = getDistinctDateFormats(
      timeSlots.map(ts => moment(ts.startDateTime)),
      "YYYY-MM"
    );

    if (ditinctMonths.includes(moment(month).format("YYYY-MM"))) {
      return;
    }

    const now = moment();
    const startOfMonth = moment(month).startOf("month");
    const start = now > startOfMonth ? now : startOfMonth;
    const end = moment(month).endOf("month");
    this.props.getTimeSlotsInPeriod(
      start,
      end,
      availableLocations,
      false,
      isPhoneConsult,
      true
    );
  };

  handleAnyClick = () => {
    const firstSlot = this.props.timeSlots[0];
    this.handleTimeSlotClick(firstSlot);
  };

  handleTimeSlotClick = ({ startDateTime, endDateTime }) => {
    const {
      updateAppointmentDetail,
      selectPreferredTime,
      toggleControl,
      completeStep,
      timeSlots,
      goToStep,
      anyPractitioner,
      anyLocation
    } = this.props;
    toggleControl(STEP_KEYS.APPOINTMENT_DATE_TIME, false);
    updateAppointmentDetail(STEP_KEYS.APPOINTMENT_DATE_TIME, {
      startDateTime,
      endDateTime
    });

    if (anyPractitioner || anyLocation) {
      let matchedTimeSlots = timeSlots.filter(
        ts =>
          ts.startDateTime === startDateTime && ts.endDateTime === endDateTime
      );
      if (!anyPractitioner) {
        matchedTimeSlots = matchedTimeSlots.filter(
          ts => ts.practitioner.practitionerId === this.props.practitioner
        );
      }
      if (!anyLocation) {
        matchedTimeSlots = matchedTimeSlots.filter(
          ts => ts.locationId === this.props.location
        );
      }
      const firstMatch = matchedTimeSlots[0];
      if (anyPractitioner) {
        updateAppointmentDetail(
          STEP_KEYS.PRACTITIONER,
          firstMatch.practitioner.practitionerId
        );
      }
      if (anyLocation) {
        updateAppointmentDetail(STEP_KEYS.LOCATION, firstMatch.locationId);
      }
    }
    selectPreferredTime("");
    goToStep(undefined);
    completeStep(STEP_KEYS.APPOINTMENT_DATE_TIME);
  };

  handlePreferredTimeSelect = time => {
    const {
      toggleControl,
      completeStep,
      selectPreferredTime,
      updateAppointmentDetail,
      goToStep,
      anyPractitioner,
      anyLocation,
      availablePractitioners,
      availableLocations
    } = this.props;
    selectPreferredTime(time);
    updateAppointmentDetail(STEP_KEYS.APPOINTMENT_DATE_TIME, undefined);

    if (anyPractitioner && availablePractitioners.length > 0) {
      updateAppointmentDetail(
        STEP_KEYS.PRACTITIONER,
        availablePractitioners[0]
      );
    }
    if (anyLocation && availableLocations.length > 0) {
      updateAppointmentDetail(STEP_KEYS.LOCATION, availableLocations[0]);
    }
    toggleControl(STEP_KEYS.APPOINTMENT_DATE_TIME, false);
    goToStep(undefined);
    completeStep(STEP_KEYS.APPOINTMENT_DATE_TIME);
    this.props.goToPage("contactform");
  };

  handleDawerRequestChange = open => {
    this.props.toggleControl(STEP_KEYS.APPOINTMENT_DATE_TIME, open);
  };

  handleGoBackToTimeslot = () => {
    this.props.requireWaitingList(false);
  };

  renderCalendar = () => {
    if (this.props.isOpen) {
      const month =
        this.state.selectedMonth &&
        this.state.selectedMonth > this.props.initialMonth
          ? this.state.selectedMonth
          : this.props.initialMonth;
      return (
        <Calendar
          month={month}
          fromMonth={this.props.initialMonth}
          availableDays={this.props.availableDays}
          selectedDays={this.state.selectedDay}
          onDayClick={this.handleDayClick}
          onMonthChange={this.handleMonthChange}
        />
      );
    }
  };

  renderLoader = () => {
    if (!this.props.loading) {
      return null;
    }

    return <LinearProgress mode="indeterminate" color="rgba(237,19,93,0.6)" />;
  };

  renderTimeSlot = () => {
    if (!this.props.isOpen) return null;

    if (this.props.availableDays.length === 0 && !this.props.loading) {
      return <Alert message="No slots in this month" />;
    }
    return this.getUniqueTimeSlots(this.state.timeSlots).map((ts, index) => {
      return (
        <TimeSlot
          key={index}
          timeSlot={ts}
          onClick={this.handleTimeSlotClick}
        />
      );
    });
  };

  renderScheduleContent = () => {
    return (
      <div>
        <span className="drawer-title">Select preferred date & time:</span>
        <FullWidthButton
          onClick={this.handleAnyClick}
          label="Next available timeslot"
          disabled={this.props.timeSlots.length === 0}
        />
        {this.props.waitingListEnabled ? (
          <FullWidthButton
            label="No suitable timeslot available"
            onClick={() => this.props.requireWaitingList(true)}
            style={{ marginTop: "20px" }}
          />
        ) : null}

        <div className="drawer-list">{this.renderCalendar()}</div>
        {this.renderLoader()}
        <div className="pick-timeslot-panel">{this.renderTimeSlot()}</div>
      </div>
    );
  };

  renderWaitingListContent = () => {
    const { waitingListPreferredTime } = this.props;
    return (
      <div>
        <span className="drawer-title">
          I Would prefer to be contacted during:
        </span>

        <PrimaryButton
          label="AM"
          icon={
            waitingListPreferredTime === "AM" ? (
              <i className="material-icons">done</i>
            ) : null
          }
          onClick={() => this.handlePreferredTimeSelect("AM")}
          style={{ display: "block" }}
        />
        <PrimaryButton
          label="PM"
          icon={
            waitingListPreferredTime === "PM" ? (
              <i className="material-icons">done</i>
            ) : null
          }
          onClick={() => this.handlePreferredTimeSelect("PM")}
          style={{
            display: "block",
            margin: "10px 0 50px 0"
          }}
        />

        <FullWidthButton
          label="Go back to select a timeslot"
          onClick={this.handleGoBackToTimeslot}
        />
      </div>
    );
  };

  renderContent = () => {
    if (this.props.isWaitingListRequired) {
      return this.renderWaitingListContent();
    }
    return this.renderScheduleContent();
  };

  render() {
    return (
      <CustomDrawer
        open={this.props.isOpen}
        onRequestChange={this.handleDawerRequestChange}
        className="schedule_drawer"
      >
        {this.renderContent()}
      </CustomDrawer>
    );
  }
}

export default connect(
  scheduleSelector,
  {
    getTimeSlotsInPeriod,
    goToPage,
    getAvailableDays,
    toggleControl,
    updateAppointmentDetail,
    goToStep,
    completeStep,
    requireWaitingList,
    selectPreferredTime
  }
)(ScheduleDrawer);



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/DrawerContent/ScheduleDrawer.js